import React, { useContext } from "react"
import { P, PAsDiv } from "../styles/TextStyles.styled"
import dark from "../../theme/dark"
import ImageCarouselItem from "./ImageCarouselItem"
import { navigate } from "gatsby"
import { urlFor } from "../../util/content-links"
import { DomainContext } from "../../context/DomainContext"
import { DomainAwareThemeProvider } from "../DomainAwareThemeProvider"

const ContactString = ({ email, phoneNumber }) => {
  const emailComponent = (
    <P as={"a"} href={`mailto:${email}`}>
      {email}
    </P>
  )
  const phoneComponent = (
    <P as={"a"} href={`tel:${phoneNumber}`}>
      {phoneNumber}
    </P>
  )
  if (email && phoneNumber) {
    return (
      <>
        {emailComponent} / {phoneComponent}
      </>
    )
  }
  if (email) {
    return emailComponent
  }
  if (phoneComponent) {
    return phoneComponent
  }
  return null
}

const TeamMemberCard = ({ reference, item, ...props }) => {
  const domainContext = useContext(DomainContext)
  const link =
    item.slug &&
    urlFor(item.__typename, item.locale, item.slug, "", domainContext)
  return (
    <ImageCarouselItem
      fluid={item.image?.fluid}
      reference={reference}
      style={{ cursor: link && "pointer" }}
      onClick={() =>
        link &&
        (link.startsWith("/") ? navigate(link) : window.open(link, "_blank"))
      }
      animateImageOnHover
      {...props}
    >
      <DomainAwareThemeProvider theme={dark}>
        <PAsDiv style={{ fontWeight: 500 }}>{item.name}</PAsDiv>
        <PAsDiv>{item.role}</PAsDiv>
        <P style={{ marginTop: "21px" }}>
          <ContactString {...item} />
        </P>
      </DomainAwareThemeProvider>
    </ImageCarouselItem>
  )
}

export default React.forwardRef((props, ref) => {
  return <TeamMemberCard {...props} reference={ref} />
})
